@if (!showHoursOnly) {
  <input
    #daysInput
    [ppAutonumeric]="autonumericOptions"
    class="pointCF__input pointCF__input--time"
    [class.pointCF__input--disabled]="ppReadOnly"
    [(ngModel)]="days"
    placeholder="d"
    (ppFormatted)="updateDaysInput($event)"
    (keydown.enter)="blurInput($event)"
    [disabled]="ppReadOnly"
  />
}

<input
  #hoursInput
  [ppAutonumeric]="autonumericOptions"
  class="pointCF__input pointCF__input--time"
  [class.pointCF__input--disabled]="ppReadOnly"
  [(ngModel)]="hours"
  placeholder="h"
  (ppFormatted)="updateHoursInput($event)"
  (keydown.enter)="blurInput($event)"
  [disabled]="ppReadOnly"
/>

<input
  #minutesInput
  [ppAutonumeric]="autonumericOptions"
  class="pointCF__input pointCF__input--time"
  [class.pointCF__input--disabled]="ppReadOnly"
  [(ngModel)]="minutes"
  placeholder="min"
  (ppFormatted)="updateMinutesInput($event)"
  (keydown.enter)="blurInput($event)"
  [disabled]="ppReadOnly"
/>

@if (ppField?.lockedValue) {
  <div class="bulkChanges__padlock">
    <pp-padlock-icon />
  </div>
}
